import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { map } from 'ramda';

import Dropzone from 'react-dropzone';

import { FILE_SIZE_LIMITS } from '../../constants/file-upload.js';
import s from './MapNoteSheetEditable.module.scss';

export default class MapNoteSheetNewHost extends Component {
    static propTypes = {
        uploadedImages: PropTypes.arrayOf(PropTypes.object),
        onImageUpload: PropTypes.func.isRequired,
        onImageDelete: PropTypes.func.isRequired,
    };

    static defaultProps = { uploadedImages: [] };

    handleOpenImageInNewTab = async image => {
        const uri = URL.createObjectURL(image);
        const win = window.open();
        win.document.write(`<image src="${uri}" allowfullscreen />`);
        window.stop();
    };

    renderImageLink = image => (
        <li key={`${image.name}-${new Date().toISOString()}`} className={s.listItem}>
            <div className={classNames('icon-image', s.imagesIcon)} />
            <button type="button" onClick={() => this.handleOpenImageInNewTab(image)} className={classNames(s.listLabel, s.removeButtonStyling)}>
                {image.name}
            </button>
            <button type="button" className={classNames('icon-closecircle', s.deleteIcon, s.removeButtonStyling)} onClick={() => this.props.onImageDelete(image)} />
        </li>
    );

    render() {
        const { uploadedImages } = this.props;
        return (
            <div className={s.addImagesButtonWrapper}>
                {uploadedImages && <ul className={s.imageList}>{map(this.renderImageLink, uploadedImages)}</ul>}
                <Dropzone onDrop={this.props.onImageUpload} maxSize={FILE_SIZE_LIMITS.MAP_NOTE_IMAGE}>
                    {({ getRootProps, getInputProps }) => (
                        <div data-testid='image-dropzone' className={classNames(s.addImagesButton, s.button)} {...getRootProps()}>
                            <input {...getInputProps()} />
                            <div className={classNames('icon-image', s.imagesIcon)} />
                            <div>Add images</div>
                        </div>
                    )}
                </Dropzone>
            </div>
        );
    }
}
